import React, { Fragment } from "react";
import { Typography, Box, Hidden, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  iconWrapper: {
    width: 36,
    height: 36,
    borderRadius: 8,
    backgroundColor: `${theme.palette.primary.main}1a`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.primary.main,
    flexShrink: 0,
  },
  label: {
    fontSize: "0.72rem",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.07em",
    color: theme.palette.text.secondary,
    whiteSpace: "nowrap",
    lineHeight: 1.8,
  },
  value: {
    fontSize: "0.875rem",
    fontWeight: 500,
    color: theme.palette.text.primary,
    maxWidth: "16rem",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    lineHeight: 1.8,
  },
  dataRow: {
    display: "flex",
    alignItems: "baseline",
    flexWrap: "wrap",
    paddingTop: 1,
    paddingBottom: 1,
    "& > *:not(:last-child)": {
      marginRight: theme.spacing(1),
    },
  },
  mobileContainer: {
    paddingTop: theme.spacing(1.5),
    paddingLeft: theme.spacing(1),
  },
}));

const Detail = ({ icon, data }) => {
  const classes = useStyles();

  return (
    <Fragment>
      <Hidden xsDown>
        <Box display="flex" flexDirection="row" mt={2} mb={1}>
          <Box className={classes.iconWrapper}>{icon}</Box>
          <Box pl={2} flexGrow={1} display="flex" flexDirection="column" justifyContent="center">
            {data.map((item, index) => (
              <Box key={index} className={classes.dataRow}>
                <Typography className={classes.label}>{item.title}</Typography>
                <Typography className={classes.value}>{item.value}</Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Hidden>
      <Hidden smUp>
        <Grid container className={classes.mobileContainer}>
          <Grid item xs={12}>
            <Box className={classes.iconWrapper}>{icon}</Box>
          </Grid>
          <Grid container item xs={12} style={{ paddingTop: 12, paddingBottom: 16 }}>
            {data.map((item, index) => (
              <Fragment key={index}>
                <Grid item xs={4}>
                  <Typography className={classes.label}>{item.title}</Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography className={classes.value}>{item.value}</Typography>
                </Grid>
              </Fragment>
            ))}
          </Grid>
        </Grid>
      </Hidden>
    </Fragment>
  );
};

export default Detail;
